import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsalert',
	templateUrl:'./BSAlertPluginCompPage.html',
	styles: [],
	styleUrls:['./BSAlertPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSAlertPluginCompPage
{
	mdContent_770 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.alerts.BSAlert;
\`\`\``;
	mdContent_771 = `\`\`\`java
BSAlert()
\`\`\``;
	mdContent_772 = `\`\`\`java
BSAlert(String text)
\`\`\``;
	mdContent_773 = `\`\`\`java
BSAlert(IComponentHierarchyBase&lt;?&gt; content)
\`\`\``;
	mdContent_774 = `\`\`\`java
BSAlert&lt;?&gt; alert = new BSAlert&lt;&gt;("Operation completed!");
alert.setDismissible(true);
alert.setType(BSColourTypes.Warning);
\`\`\``;
}
